/** Liste les différents mode de sauvegarde possibles d'un objet */
enum SaveModeEnum {
	NewObject,
	NewVersion,
	UpdateObject,
	UpdateVersion
}

export default SaveModeEnum;